export default __webpack_public_path__ + "static/media/offlinepayment.ba25573c.png";